<div class="checkbox-item">
    <input type="checkbox" [id]="uniqueId" [(ngModel)]="binding">
    <label [for]="uniqueId">
        <span class="custom-checkbox">
            <svg viewBox="0 0 24 24" class="checkmark">
                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"></path>
            </svg>
        </span>
        <div class="truncated">{{label}}</div>
    </label>
</div>